<template>
  <div class="app">
    <div style="padding-right:8px;display:flex;position: fixed;z-index: 99;background-color:white;flex-direction: column;"
      v-if="isMobile">
      <div style="display:flex;">
        <div style="display:flex;align-items: center;justify-content: center;">
          <img src="./img/zhanshi.png" alt="logo" class="logo" />
        </div>
        <Header :activeIndex="3" />
      </div>
      <div class="hengtiao">
        <div class="xiangji"><i class="el-icon-camera"></i></div>
        <div class="gerenxinxi">简历列表</div>
      </div>
    </div>
    <div class="hengtiao1" v-if="!isMobile">
    </div>
    <div class="hengtiao" v-if="!isMobile">
      <div class="xiangji"><i class="el-icon-camera"></i></div>
      <div class="gerenxinxi">简历列表</div>
    </div>
    <div class="head01">
      <Header :activeIndex="3" v-if="!isMobile" />
      <div class="neirong">
        <el-select v-model="value" placeholder="请选择" @change="handleChange">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-table :data="disTableData" stripe style="width: 100%;" :height="tableHeight" v-if="!isMobile">
          <el-table-column label="序号" width="100">
            <template #default="scope">
              {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="jobName" label="岗位名称" width="270">
          </el-table-column>
          <el-table-column prop="userName" label="姓名" width="130">
          </el-table-column>
          <el-table-column prop="birthday" label="年龄" width="110">
            <template #default="{ row }">
              <div>{{ calculateAge(row.birthday) }}岁</div>
            </template>
          </el-table-column>
          <el-table-column prop="almaMater" label="学校" width="250">
          </el-table-column>
          <el-table-column prop="degree" label="学历" width="120">
          </el-table-column>
          <el-table-column prop="major" label="专业" width="180">
          </el-table-column>
          <el-table-column prop="graduationDate" label="毕业时间" width="150">
            <template #default="{ row }">
              <div>{{ formatDate(row.graduationDate) }}</div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="disTableData" stripe style="width: 100%;" v-else>
          <el-table-column label="序号" width="70">
            <template #default="scope">
              {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="jobName" label="岗位名称" width="150">
          </el-table-column>
          <el-table-column prop="userName" label="姓名" width="110">
          </el-table-column>
          <el-table-column prop="birthday" label="年龄" width="100">
            <template #default="{ row }">
              <div>{{ calculateAge(row.birthday) }}岁</div>
            </template>
          </el-table-column>
          <el-table-column prop="almaMater" label="学校" width="250">
          </el-table-column>
          <el-table-column prop="degree" label="学历" width="120">
          </el-table-column>
          <el-table-column prop="major" label="专业" width="180">
          </el-table-column>
          <el-table-column prop="graduationDate" label="毕业时间" width="150">
            <template #default="{ row }">
              <div>{{ formatDate(row.graduationDate) }}</div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="50">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total"
          style="margin-top: 20px;" small></el-pagination>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from './qiyeHeader.vue'
import Footer from './Footer.vue'
export default {
  name: 'downloadresume',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      tableStyle: {
        width: '100%',
        height: `${window.innerHeight - 400}px` // 动态调整表格的高度
      },
      tableData: [],
      userId: sessionStorage.getItem("downUserId"),
      pageSize: 20,
      currentPage: 1,
      total: 0,
      tableHeight: "",
      // BASE_URL: 'http://192.168.2.8:8206',
      // BASE_URL2: 'http://192.168.2.8:8204',
      BASE_URL: 'https://zhiyedashi.com/info',
      BASE_URL2: 'https://zhiyedashi.com/job',
      qiyeId: sessionStorage.getItem("qiyeId"),
      disTableData: [],
      options: [],
      value: '全部',
      isMobile: false
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  created() {
    if (!this.qiyeId) {
      console.warn('关键数据未获取到，停止执行后续逻辑');
      this.$router.push('/')
    }
    this.selectJobs()
    this.getTableHeight();
    this.selectTableData()
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleChange(value) {
      // console.log("选择", value);
      this.currentPage = 1
      if (value === '全部') {
        this.selectTableData()
      } else {
        this.selectResumes()
      }
    },
    selectJobs() {
      fetch(`${this.BASE_URL2}/admin/qiyejob/selectJobName`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `qiyeId=${this.qiyeId}`,
      })
        .then((res) => res.json())
        .then((data) => {
          // console.log("1:查询岗位", data);
          if (data.data !== '没有数据') {
            const options = data.data.map((item) => ({
              value: item,
              label: item
            }));

            this.options = [
              { value: '全部', label: '全部' },
              ...options
            ];
          } else {
            this.jobOptions = [{ value: '全部', label: '全部' }];
          }
        })
        .catch((error) => {
          console.error("查询职业失败,原因是", error);
        })
    },
    handleClick(row) {
      // console.log(row);
      sessionStorage.setItem("talentId", row.talentId);
      sessionStorage.setItem("linshiUserId", row.userId);
      localStorage.setItem("star", "1");
      localStorage.setItem("currentPage", this.currentPage);
      localStorage.setItem("jobName", row.jobName);
      this.$router.push('/downreport');
    },
    calculateAge(birthday) {
      const birthDate = new Date(birthday);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    formatDate(isoString) {
      const date = new Date(isoString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}年${month}月${day}日`;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.updateDisplayData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.updateDisplayData()
    },
    updateDisplayData() {
      const start = (this.currentPage - 1) * this.pageSize;
      this.disTableData = this.tableData.slice(start, start + this.pageSize);
    },
    selectTableData() {
      fetch(`${this.BASE_URL}/admin/resumes/selectStar`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `qiyeId=${this.qiyeId}`
      })
        .then(res => res.json())
        .then(data => {
          this.tableData = data.data
          this.total = data.data.length
          this.updateDisplayData()
        })
        .catch(error => {
          console.error("查询收藏学生失败，原因是", error);
        })
    },
    selectResumes() {
      fetch(`${this.BASE_URL}/admin/resumes/selectStarByJobName`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `qiyeId=${this.qiyeId}&jobName=${this.value}`
      })
        .then(res => res.json())
        .then(data => {
          this.tableData = data.data
          this.total = data.data.length
          this.updateDisplayData()
        })
        .catch(error => {
          console.error("查询收藏学生失败，原因是", error);
        })
    },
    getTableHeight() {
      let tableH = 310;
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 300) {
        this.tableHeight = 300;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },
  }
}
</script>
<style scoped>
.hengtiao1 {
  height: 8px;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
}

.hengtiao {
  height: 50px;
  width: 100%;
  background-color: #3572e5;
  color: white;
  display: flex;
  align-items: center;
}

.xiangji {
  margin-left: 20px;
  font-weight: 800;
  font-size: 28px;
}

.gerenxinxi {
  margin-left: 20px;
  font-weight: 700;
}

.head01 {
  display: flex;
  gap: 100px;
}

.neirong {
  display: flex;
  gap: 30px;
  margin-top: 30px;
  flex-direction: column;
}

@media (max-width: 768px) {
  .logo {
    width: 50px;
  }

  .head01 {
    flex-direction: column;
    gap: 20px;
    padding-top: 140px;
  }

  .neirong {
    gap: 10px;
    margin-top: 20px;
    padding: 0 15px;
  }

  .hengtiao {
    height: 50px;
    width: 100%;
    background-color: #3572e5;
    color: white;
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/downloadresume.vue